import React, { useEffect, useRef, useState, useMemo } from "react";

import { useSelector, useDispatch } from "react-redux";

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useTranslation } from "react-i18next";

import API from "../../app/api";

import _ from "lodash";
import moment from "moment";
// import clsx from "clsx";

// eslint-disable-next-line no-unused-vars
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

import MessageBox from "../../util/messageBox";
import config from "../../app/config";

import { patient } from "../../store/reducers/patient";
import {documents, loadDocumentsForPatientById} from '../../store/reducers/documents';

import Formatter from "../../util/formatter";
import $ from "jquery";

import cornerstone from "cornerstone-core";
import cornerstoneTools from "cornerstone-tools";

import {
  setGlobalVariable,
  globalVariable, setSnackbar,
} from "../../store/reducers/globals";
import {
  setViewData,
  setViewCurrentPage,
  referenceForSOP,
} from "../../store/reducers/views";

import { getImageChannel } from "./mods";

// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";
import Slider from "@mui/material/Slider";
import LinearProgress from "@mui/material/LinearProgress";
import { patient as patientPreferences } from '../../store/reducers/preferences';
import { EyonixGridA, EyonixGridB, EyonixGridC } from '../../components/icons/icons';
import TaskExecutor from './taskExecutor';
import {globalImageCache} from './imageCache';

const BoldLinearProgress = withStyles((theme) => ({
  root: {
    height: 5,
    // borderRadius: 5,
  },
}))(LinearProgress);

const tools = [
  "TextMarker",
  "Length",
  "SimpleTextTool",
  "ArrowAnnotate",
  "FreehandRoi",
  "FreehandPDT",
  "EllipticalRoi",
  "RectangleRoi",
  "Angle",
  "FormAnnotate",
  "GridABCTool",
  "TextMarkerResize",
];

const useStyles = makeStyles((theme) => ({
  base: {
    width: "100%",
    height: "100%",
    border: "0 !important",
  },
  backdropBack: {
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#000",
    opacity: 0.5,
  },
  backdrop: {
    width: "100%",
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: theme.zIndex.drawer + 2,
  },
  laterality: {
    fontSize: 30,
    color: "#e88f05"
  }
}));

const getImageFitScale = (windowSize, image, rotation = null) => {
  const imageSize = {
    width: image.width,
    height: image.height,
  };
  const rowPixelSpacing = image.rowPixelSpacing || 1;
  const columnPixelSpacing = image.columnPixelSpacing || 1;

  let verticalRatio = 1;
  let horizontalRatio = 1;

  if (rowPixelSpacing < columnPixelSpacing) {
    horizontalRatio = columnPixelSpacing / rowPixelSpacing;
  } else {
    // even if they are equal we want to calculate this ratio (the ration might be 0.5)
    verticalRatio = rowPixelSpacing / columnPixelSpacing;
  }

  const verticalScale = windowSize.height / imageSize.height / verticalRatio;
  const horizontalScale =
      windowSize.width / imageSize.width / horizontalRatio;

  return {
    verticalScale,
    horizontalScale,
    scaleFactor: Math.min(horizontalScale, verticalScale),
  };
};

function ViewDocumentDicom(props) {
  const classes = useStyles();
  const [actionSelected, setActionSelected] = useState(null);
  const [enhanceSelected, setEnhanceSelected] = useState(null);
  const [channelsSelected, setChannelsSelected] = useState(null);
  const [annotationsWithText, setAnnotationsWithText] = useState(false);

  const [globalSharpenValue, setGlobalSharpenValue] = useState(0);
  const [globalBlurValue, setGlobalBlurValue] = useState(0);

  const [enhanceProperties, setEnhanceProperties] = useState({});

  const [selectedDocument, setSelectedDocument] = useState(props.document);
  const [currentPage, setCurrentPage] = useState( 1);

  const [loading, setLoading] = useState(true);
  const [loadingBuffering, setLoadingBuffering] = useState(false);
  const [loadingBarVisible, setLoadingBarVisible] = useState(true);
  const [savingBarVisible, setSavingBarVisible] = useState(false);
  const [visiblePage, setVisiblePage] = useState(1);

  const [viewportData, setViewportData] = useState(null);

  const [pixelSpacing, setPixelSpacing] = useState(null);

  const [metadata, setMetadata] = useState(null);

  const document = selectedDocument;
  const dispatch = useDispatch();

  // eslint-disable-next-line no-unused-vars
  const { t, i18n } = useTranslation();

  const rootElement = useRef(null);

  const [parentSize, setParentSize] = useState([0, 0]);
  const parentElement = useRef(null);
  if (parentElement && parentElement.current) {
    const localSize = parentElement.current.getBoundingClientRect();
    if (
        localSize.width !== parentSize[0] ||
        localSize.height !== parentSize[1]
    ) {
      setParentSize([localSize.width, localSize.height]);
    }
  }

  useEffect(() => {
    if (parentSize[0] !== 0 && parentSize[1] !== 0) {
      const domElement = rootElement.current;
      let enabled = false;
      const elements = cornerstone.getEnabledElements();
      for (const element of elements) {
        enabled = element.element === domElement;
        if (enabled) break;
      }
      if (enabled) {
        // cornerstone.resize(domElement, true);
        cornerstone.resize(domElement, false);
      }
    }
    return () => { };
  }, [parentSize]);

  const patientObject = useSelector(patient);

  const variableName = "toolbarViewer" + props.viewerId;
  const toolbarViewer = useSelector(globalVariable(variableName));
  const toolbarViewerQuickAction = useSelector(
      globalVariable("toolbarViewerQuickAction")
  );

  const imageLoadDebounce = useMemo(() => {
    return _.debounce((afterExecutedMethod) => {
      afterExecutedMethod();
    }, config.modules.viewer.defaultImageLoadDebounceTime);
  }, []);

  useEffect(() => {
    resetView();
    setSelectedDocument(props.document);
    if(props.currentPage && props.currentPage !== currentPage && props.document.pageCount > 1) {
      setCurrentPage(props.currentPage);
    } else {
      setCurrentPage(1);
    }

    return () => { };
  }, [props.document]);

  useEffect(() => {
    if (viewportData) {
      const domElement = rootElement.current;
      let viewport = cornerstone.getViewport(domElement);
      viewport.scale = props.zoom / 1000;
      cornerstone.setViewport(domElement, viewport);
    }
    return () => { };
  }, [props.zoom]);

  useEffect(() => {
    const domElement = rootElement.current;
    let enabled = false;
    const elements = cornerstone.getEnabledElements();
    for (const element of elements) {
      enabled = element.element === domElement;
      if (enabled) break;
    }
    if (enabled) {
      cornerstone.resize(domElement);
    }
    return () => { };
  }, [props.height]);

  const getImageUrl = (page) => {
    return `${config.imageDownloadURL}/${document.externalId}/attachment/LO${page}`;
  };

  const getImageUrlFull = (page) => {
    return `${config.imageDownloadURL}/${document.externalId}/attachment/HI${page}`;
  };

  const documentsObject = useSelector(documents);
  const [imageDicomCornerstone, setImageDicomCornerstone] = useState(null);
  const [imageDicomCornerstoneBase, setImageDicomCornerstoneBase] =
      useState(null);
  const [lastDisplayedImageId, setLastDisplayedImageId] = useState(undefined);

  const uniqueId = props.document.metadata.uniqueId;
  const referencesSOP = useSelector(referenceForSOP(uniqueId));

  const isViewLocked = (index) => {
    if (index < window.__lockedDocuments.length) {
      return window.__lockedDocuments[index];
    }
    return false;
  };

  useEffect(() => {
    const pageChangeEvent = e => {
      if (isViewLocked(props.viewerId - 1)) {
        if (e.detail.page !== currentPage && e.detail.page <= document.pageCount) {
          setCurrentPage(e.detail.page);
        }
      }
    };

    window.dispatchEvent(
        new CustomEvent(
            "pageForLockedChangeEvent",
            {
              detail: {
                page: currentPage
              },
            }
        ));

    window.addEventListener("pageForLockedChangeEvent", pageChangeEvent);
    return () => {
      window.removeEventListener(
          "pageForLockedChangeEvent",
          pageChangeEvent
      );
    };
  }, [currentPage]);

  useEffect(() => {
    const relatedRegionClick = (e) => {
      if (props.document.metadata.relatedDocument === e.detail.uniqueId) {
        // console.log(
        //     "relatedRegionClick",
        //     props.document.metadata,
        //     e.detail
        // );
        setCurrentPage(e.detail.index);
      }
    };
    window.addEventListener("relatedRegionClick", relatedRegionClick);
    return () => {
      window.removeEventListener(
          "relatedRegionClick",
          relatedRegionClick
      );
    };
  }, [props.document]);

  useEffect(() => {
    const panHandle = (data) => {

      const _getTranslation = (eventData) => {
        const { viewport, image, deltaPoints } = eventData;

        let widthScale = viewport.scale;
        let heightScale = viewport.scale;

        if (image.rowPixelSpacing < image.columnPixelSpacing) {
          widthScale *=
              image.columnPixelSpacing / image.rowPixelSpacing;
        } else if (image.columnPixelSpacing < image.rowPixelSpacing) {
          heightScale *=
              image.rowPixelSpacing / image.columnPixelSpacing;
        }

        return {
          x: deltaPoints.page.x / widthScale,
          y: deltaPoints.page.y / heightScale,
        };
      };

      if (
          data.detail.viewIndex !== props.viewerId &&
          // && isViewLocked(data.detail.viewIndex - 1)
          isViewLocked(props.viewerId - 1)
      ) {
        const domElement = rootElement.current;
        let viewport = cornerstone.getViewport(domElement);

        const translation = _getTranslation(data.detail.eventData);
        viewport.translation.x += translation.x;
        viewport.translation.y += translation.y;
        cornerstone.setViewport(domElement, viewport);
      }
    };
    const zoomHandle = (data) => {
      if (isViewLocked(props.viewerId - 1)) {
        const domElement = rootElement.current;
        let viewport = cornerstone.getViewport(domElement);

        viewport.scale = data.detail.updatedViewport.scale;
        viewport.translation.x -= data.detail.shift.x;
        viewport.translation.y -= data.detail.shift.y;
        cornerstone.setViewport(domElement, viewport);

      }
    }
    window.addEventListener("panChange", panHandle);
    window.addEventListener("zoomChange", zoomHandle);
    return () => {
      window.removeEventListener("panChange", panHandle);
      window.removeEventListener("zoomChange", zoomHandle);
    };
  }, [
    imageDicomCornerstone,
    toolbarViewer,
    metadata,
    referencesSOP,
    props,
    loadingBarVisible,
  ]);

  useEffect(() => {
    if (referencesSOP && imageDicomCornerstone) {
      const referencesToShow = referencesSOP[0];
      const onImageRendered = (e) => {
        let viewport = cornerstone.getViewport(domElement);
        setViewportData(viewport);

        if (
            loadingBarVisible ||
            (toolbarViewer && !toolbarViewer.imageInformation)
        ) {
          return;
        }

        if (metadata && metadata.dicom && imageDicomCornerstone) {
          const originalWidth = metadata.dicom["00280011"].Value[0];
          const originalHeight = metadata.dicom["00280010"].Value[0];

          const recalculate = (x, y) => {
            const widthFactor =
                imageDicomCornerstone.width / originalWidth;
            const heightFactor =
                imageDicomCornerstone.height / originalHeight;

            return {
              x: x * widthFactor,
              y: y * heightFactor,
            };
          };

          const eventData = e.detail;
          const context = eventData.canvasContext;
          _.forEach(referencesToShow.refs.frames, (frame) => {
            const path = new Path2D();
            if (frame.orientation === 'TRANSVERSE') {
              let topLeft = recalculate(
                  frame.coordinates[0].x,
                  frame.coordinates[0].y,
              );
              let bottomRight = recalculate(
                  frame.coordinates[1].x,
                  frame.coordinates[1].y,
              );

              path.rect(
                  topLeft.x,
                  topLeft.y,
                  bottomRight.x - topLeft.x,
                  bottomRight.y - topLeft.y,
              );
            } else {
              // LINEAR, NONLINEAR
              let startPoint = true;
              _.forEach(frame.coordinates, (point) => {
                let pt = recalculate(point.x, point.y);
                if (startPoint) {
                  startPoint = false;
                  path.moveTo(
                      pt.x,
                      pt.y,
                  );
                } else {
                  path.lineTo(
                      pt.x,
                      pt.y,
                  );
                }
              });
            }

            // FIXME: ... some sort of proper colors here ???

            if (
                frame.sequenceNumber ===
                referencesToShow.currentPage
            ) {
              context.strokeStyle = "blue";
              context.lineWidth = 2;
            } else {
              context.strokeStyle = "green";
              context.lineWidth = 1;
            }

            context.beginPath();
            context.stroke(path);
            context.closePath();
          });
        }
      };

      const domElement = rootElement.current;
      let enabled = false;
      const elements = cornerstone.getEnabledElements();
      for (const element of elements) {
        enabled = element.element === domElement;
        if (enabled) break;
      }

      if (enabled) {
        domElement.addEventListener(
            "cornerstoneimagerendered",
            onImageRendered
        );
        const timeoutId = setTimeout(() => {
          // FIXME: not sure how but we need to get rid of this ...
          cornerstone.updateImage(domElement);
        }, 1);

        const onCanvasClick = function (event) {
          // var x = event.pageX - elemLeft,
          //     y = event.pageY - elemTop;

          // // Collision detection between clicked offset and element.
          // elements.forEach(function(element) {
          //     if (y > element.top && y < element.top + element.height
          //         && x > element.left && x < element.left + element.width) {
          //         alert('clicked an element');
          //     }
          // });

          let x = event.pageX;
          let y = event.pageY;

          let enabledElement;
          const elements = cornerstone.getEnabledElements();
          for (const element of elements) {
            const enabled = element.element === domElement;
            if (enabled) {
              enabledElement = element;
              break;
            }
          }
          if (enabledElement) {
            const context = enabledElement.canvas.getContext("2d");

            if (referencesSOP && imageDicomCornerstone) {
              const referencesToShow = referencesSOP[0];
              if (referencesToShow) {
                const originalWidth =
                    metadata.dicom["00280011"].Value[0];
                const originalHeight =
                    metadata.dicom["00280010"].Value[0];

                const recalculate = (x, y) => {
                  const widthFactor =
                      imageDicomCornerstone.width /
                      originalWidth;
                  const heightFactor =
                      imageDicomCornerstone.height /
                      originalHeight;

                  return {
                    x: x * widthFactor,
                    y: y * heightFactor,
                  };
                };

                _.forEach(
                    referencesToShow.refs.frames,
                    (frame, index) => {
                      const path = new Path2D();
                      if (frame.orientation === 'TRANSVERSE') {
                        let topLeft = recalculate(
                            frame.coordinates[0].x,
                            frame.coordinates[0].y,
                        );
                        let bottomRight = recalculate(
                            frame.coordinates[1].x,
                            frame.coordinates[1].y,
                        );

                        path.rect(
                            topLeft.x,
                            topLeft.y,
                            bottomRight.x - topLeft.x,
                            bottomRight.y - topLeft.y,
                        );
                      } else {
                        // LINEAR, NONLINEAR
                        let startPoint = true;
                        _.forEach(frame.coordinates, (point) => {
                          let pt = recalculate(point.x, point.y);
                          if (startPoint) {
                            startPoint = false;
                            path.moveTo(
                                pt.x,
                                pt.y,
                            );
                          } else {
                            path.lineTo(
                                pt.x,
                                pt.y,
                            );
                          }
                        });
                      }

                      context.lineWidth = 7;

                      if (
                          context.isPointInStroke(
                              path,
                              event.offsetX,
                              event.offsetY
                          )
                      ) {
                        const uniqueId =
                            props.document.metadata
                                .uniqueId;
                        window.dispatchEvent(
                            new CustomEvent(
                                "relatedRegionClick",
                                {
                                  detail: {
                                    uniqueId: uniqueId,
                                    seq:
                                    frame.sequenceNumber,
                                    index: index + 1
                                  },
                                }
                            )
                        );
                      }
                    }
                );
              }
            }
          }
        };
        domElement.addEventListener("click", onCanvasClick, false);

        return () => {
          clearTimeout(timeoutId);
          domElement.removeEventListener(
              "cornerstoneimagerendered",
              onImageRendered
          );
          domElement.removeEventListener("click", onCanvasClick);
        };
      }
    }
    return () => { };
  }, [
    imageDicomCornerstone,
    toolbarViewer,
    metadata,
    referencesSOP,
    props,
    loadingBarVisible,
  ]);

  useEffect(
      () => {
        if (toolbarViewer) {
          if (toolbarViewer.documentId !== selectedDocument.__id) {
            const newToolBarDef = _.cloneDeep(toolbarViewer);
            newToolBarDef.documentId = selectedDocument.__id;
            dispatch(
                setGlobalVariable({
                  name: variableName,
                  value: newToolBarDef,
                })
            );
          }
        }
        return () => { };
      },
      [toolbarViewer, selectedDocument]
  );


  const setActiveTool = (domElement, annotationsTextVisible = false) => {
    if (toolbarViewer) {

      if (toolbarViewer.activeMethod === "zoom") {
        cornerstoneTools.setToolActiveForElement(domElement, "Zoom", {
          mouseButtonMask: toolbarViewer.mouseButton || 1,
          viewIndex: props.viewerId,
        });
      }
      if (toolbarViewer.activeMethod === "pan") {
        // cornerstoneTools.setToolActiveForElement(domElement, "Pan", { mouseButtonMask: 1 });
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "PanBroadcast",
            {
              viewIndex: props.viewerId,
              mouseButtonMask: 1,
            }
        );
      }
      if (toolbarViewer.activeMethod === "flying-zoom") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "Magnify",
            { mouseButtonMask: 1 }
        );
      }

      if (toolbarViewer.activeMethod === "draw-text") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "TextMarker",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
            }
        );
        // cornerstoneTools.setToolActiveForElement(domElement, 'SimpleTextTool', {
        //     mouseButtonMask: 1,
        //     deleteIfHandleOutsideImage: false,
        //     preventHandleOutsideImage: false,
        // });
      }
      if (toolbarViewer.activeMethod === "draw-arrow") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "ArrowAnnotate",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
            }
        );
      }
      if (toolbarViewer.activeMethod === "draw-form") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "FormAnnotate",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
            }
        );
      }
      if (toolbarViewer.activeMethod === "grid-view") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "GridABCTool",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
              annotationTextVisible: annotationsTextVisible,
              gridType: "A"
            }
        );
      }
      if (toolbarViewer.activeMethod === "grid-view-B") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "GridABCTool",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
              annotationTextVisible: annotationsTextVisible,
              gridType: "B"
            }
        );
      }
      if (toolbarViewer.activeMethod === "grid-view-C") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "GridABCTool",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
              annotationTextVisible: annotationsTextVisible,
              gridType: "C"
            }
        );
      }
      if (toolbarViewer.activeMethod === "draw-line") {
        cornerstoneTools.setToolActiveForElement(domElement, "Length", {
          mouseButtonMask: 1,
          deleteIfHandleOutsideImage: false,
          preventHandleOutsideImage: false,
          annotationTextVisible: annotationsTextVisible
        });
      }
      if (toolbarViewer.activeMethod === "draw-free-hand") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "FreehandRoi",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
              annotationTextVisible: annotationsTextVisible
            }
        );

      }
      if (toolbarViewer.activeMethod === "draw-free-hand-pdt") {
        if (pixelSpacing && pixelSpacing.rowPixelSpacing === pixelSpacing.columnPixelSpacing) {
          cornerstoneTools.setToolActiveForElement(
              domElement,
              "FreehandPDT",
              {
                mouseButtonMask: 1,
                deleteIfHandleOutsideImage: false,
                preventHandleOutsideImage: false,
                annotationTextVisible: annotationsTextVisible
              }
          );
        }
      }

      if (toolbarViewer.activeMethod === "draw-ellipse") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "EllipticalRoi",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
              annotationTextVisible: annotationsTextVisible
            }
        );
      }
      if (toolbarViewer.activeMethod === "draw-rect") {
        cornerstoneTools.setToolActiveForElement(
            domElement,
            "RectangleRoi",
            {
              mouseButtonMask: 1,
              deleteIfHandleOutsideImage: false,
              preventHandleOutsideImage: false,
              annotationTextVisible: annotationsTextVisible
            }
        );
      }
      if (toolbarViewer.activeMethod === "angle-tool") {
        cornerstoneTools.setToolActiveForElement(domElement, "Angle", {
          mouseButtonMask: 1,
          deleteIfHandleOutsideImage: false,
          preventHandleOutsideImage: false,
          annotationTextVisible: annotationsTextVisible
        });
      }
      if (toolbarViewer.activeMethod === "eraser-tool") {
        cornerstoneTools.setToolActiveForElement(domElement, "Eraser", {
          mouseButtonMask: 1,
          deleteIfHandleOutsideImage: false,
          preventHandleOutsideImage: false,
        });
      }
      if (toolbarViewer.activeMethod === "draw-resize-text") {
        cornerstoneTools.setToolActiveForElement(
          domElement,
          "TextMarkerResize",
          {
            mouseButtonMask: 1,
            deleteIfHandleOutsideImage: false,
            preventHandleOutsideImage: false,
          },
        );
      }

      let documentIsFinal = (selectedDocument &&
          (selectedDocument.metadata?.annotationFinal ||
              (selectedDocument.metadata?.isOldCopy && !selectedDocument.metadata?.finalPages) ||
              (selectedDocument.metadata?.finalPages?.finalPages?.includes(currentPage))));


      if (documentIsFinal)
        setToolEnabled(domElement)
    }
  };

  const setToolEnabled = (domElement) => {
    cornerstoneTools.setToolEnabledForElement(domElement, "EllipticalRoi", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "Eraser", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "Angle", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "RectangleRoi", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "FreehandRoi", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "EllipticalRoi", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "Length", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "TextMarker", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "ArrowAnnotate", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "FormAnnotate", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "GridABCTool", {
      showUser: props.docModalVisible,
    });
    cornerstoneTools.setToolEnabledForElement(domElement, "TextMarkerResize", {
      showUser: props.docModalVisible,
    });
  };

  const patientPreferencesObject = useSelector(patientPreferences);

  useEffect(
      () => {
        if (!toolbarViewer) {
          dispatch(
              setGlobalVariable({
                name: variableName,
                value: {
                  channelsMode: null,
                  enhanceMode: null,
                  toolsProperties: {
                    fontSize: patientPreferencesObject.fontSize,
                    toolWidth: 3,
                    // color: patientPreferencesObject.color,
                  },
                  haveSquareMeasurements: false,
                  enhanceModeParameters: {
                    blur: 0,
                    brightness: 0,
                    sharpen: 0,
                    contrast: 0,
                    gamma: 0,
                    zoom: 1,
                  },
                  mode: "dicom",
                  activeMethod: "pan",
                  imageInformation: "info",
                  //  relatedVisible: "related",
                  relatedFramesVisible: "related-frames",
                  activeXUP: null,
                  documentId: selectedDocument.__id,
                },
              })
          );
        }
        if (toolbarViewer) {
          if (actionSelected !== toolbarViewer.activeMethod) {
            setActionSelected(toolbarViewer.activeMethod);
          }
          if (channelsSelected !== toolbarViewer.channelsMode) {
            setChannelsSelected(toolbarViewer.channelsMode);
          }
          if (enhanceSelected !== toolbarViewer.enhanceMode) {
            setEnhanceSelected(toolbarViewer.enhanceMode);
          }
          setEnhanceProperties(toolbarViewer.enhanceModeParameters);

          // console.log("toolbarViewer.toolsProperties.fontSize", toolbarViewer.toolsProperties.fontSize);

          cornerstoneTools.textStyle.setFont(
              `${toolbarViewer.toolsProperties.fontSize}px Roboto`
          );
          cornerstoneTools.textStyle.setFontSize(
              toolbarViewer.toolsProperties.fontSize - 2
          );

          // cornerstoneTools.toolColors.setToolColor(
          //         toolbarViewer.toolsProperties.color
          // );

          if (annotationsWithText !== toolbarViewer.toolsProperties.annotationText) {
            setAnnotationsWithText(toolbarViewer.toolsProperties.annotationText);
          }

          if (props.isActive) {
            const domElement = rootElement.current;
            setActiveTool(domElement, toolbarViewer.toolsProperties.annotationText);
          }
        }
        return () => { };
      },
      [toolbarViewer, props.isActive, props.docModalVisible]
  );

  const [gridVisible, setGridVisible] = useState(false);
  const [gridItem, setGridItem] = useState(null);

  useEffect(
      () => {
        if (props.isActive) {
          if (toolbarViewerQuickAction) {
            const actionAndParameter =
                toolbarViewerQuickAction.split(":");

            const getDocumentById = (docId) => {
              let foundedDocument = null;
              if (documentsObject.__data) {
                for (let document of documentsObject.__data)
                  if (docId === document.__id) {
                    foundedDocument = document;
                    break;
                  }
              }
              return foundedDocument;
            };

            const domElement = rootElement.current;

            let enabledElement;
            const elements = cornerstone.getEnabledElements();
            for (const element of elements) {
              const enabled = element.element === domElement;
              if (enabled) {
                enabledElement = element;
                break;
              }
            }
            // eslint-disable-next-line default-case
            const viewPort = cornerstone.getViewport(domElement);
            switch (actionAndParameter[0]) {
              case "open":
                if (documentsObject) {
                  const doc = getDocumentById(
                      actionAndParameter[1]
                  );
                  // console.log("doc", doc);
                  setSelectedDocument(doc);
                }
                break;
              case "actualSizeAction":
                let viewport = cornerstone.getViewport(domElement);
                viewport.scale = 1;
                viewport.translation.x = 0;
                viewport.translation.y = 0;
                cornerstone.setViewport(domElement, viewport);
                break;
              case "fullscreen":
              function toggleFullScreen() {
                if (!window.document.fullscreenElement) {
                  // parentElement.current.requestFullscreen();
                  window.document
                      .getElementById("viewer")
                      .requestFullscreen();
                } else {
                  if (window.document.exitFullscreen) {
                    window.document.exitFullscreen();
                  }
                }
              }

                toggleFullScreen();
                break;
              case "replaceDOR":
                //console.log("replaceDOR");
                saveDorDocument(enabledElement, domElement, true, true);
                break;
              case "saveDOR":
                //console.log("saveDOR");
                saveDorDocument(enabledElement, domElement);
                break;
              case "rotate-page-left":
                viewPort.rotation-=90;
                cornerstone.setViewport(domElement, viewPort);
                break;
              case "rotate-page":
                viewPort.rotation+=90;
                cornerstone.setViewport(domElement, viewPort);
                break;
              case "fullWidthAction":
                if (enabledElement) {
                  let viewport = cornerstone.getViewport(domElement);
                  cornerstone.setViewport(domElement, viewport);

                  const scaleObject = getImageFitScale(
                      enabledElement.canvas,
                      enabledElement.image,
                      enabledElement.viewport.rotation
                  );
                  enabledElement.viewport.scale =
                      scaleObject.horizontalScale;
                  enabledElement.viewport.translation.x = 0;
                  enabledElement.viewport.translation.y = 0;
                  cornerstone.updateImage(domElement);

                  // cornerstone.fitToWindow(domElement);
                }
                break;
              case "fitToWindowAction":
                if (enabledElement) {
                  const domElement = rootElement.current;
                  cornerstone.fitToWindow(domElement);
                }
                break;
              case "fullHeightAction":
                if (enabledElement) {
                  let viewport =
                      cornerstone.getViewport(domElement);
                  cornerstone.setViewport(domElement, viewport);

                  const scaleObject = getImageFitScale(
                      enabledElement.canvas,
                      enabledElement.image,
                      enabledElement.viewport.rotation
                  );
                  enabledElement.viewport.scale =
                      scaleObject.verticalScale;
                  enabledElement.viewport.translation.x = 0;
                  enabledElement.viewport.translation.y = 0;
                  cornerstone.updateImage(domElement);
                }
                break;
              case "gridA":
              case "gridB":
              case "gridC":
                handleOpenGrid(actionAndParameter[0])
                break;
              case "gridRemove":
                setGridVisible(false);
                break;
            }

            dispatch(
                setGlobalVariable({
                  name: "toolbarViewerQuickAction",
                  value: null,
                })
            );
          }
        }
        return () => { };
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [toolbarViewerQuickAction, props.isActive]
  );


  const newDocId = useRef(null);

  const saveDorDocument = (enabledElement, domElement, refreshDocs= false, deleteOldDoc= false) => {
    if (enabledElement && enabledElement.image && (!selectedDocument.metadata.finalPages || !selectedDocument.metadata.finalPages.finalPages.includes(currentPage))) {

      dispatch(setGlobalVariable({
        name: "savingDor",
        value: true,
      }));

      setSavingBarVisible(true);

      let rot = 0;

      const onImageRenderedPrev = () => {

        const imagePngWithAnnotation = enabledElement.canvas.toDataURL("image/png");

        domElement.removeEventListener(
            "cornerstoneimagerendered",
            onImageRenderedPrev
        );

        function urltoFile(
            url,
            filename,
            mimeType
        ) {
          return fetch(url)
              .then(function (res) {
                return res.arrayBuffer();
              })
              .then(function (buf) {
                return new File(
                    [buf],
                    filename,
                    {type: mimeType}
                );
              });
        }

        urltoFile(
            imagePngWithAnnotation,
            "image.png",
            "image/png"
        ).then(function (file) {
          let prevData = {
            catalog: `${props.patientId}`,
            type: "attachment",
            userId: "PREV1",
            referenceId: newDocId.current,
          }

          const imageSaveFormData = new FormData();
          imageSaveFormData.append("metadata", JSON.stringify(prevData));
          imageSaveFormData.append("file", file);

          axios({
            method: "post",
            url: config.imageUploadAttachURL,
            data: imageSaveFormData,
            headers: {
              Authorization: `Bearer ${window.keycloak ? window.keycloak.token : window.auth.token}`,
              "Content-Type": "multipart/form-data",
            },
          })
              .then(function (response) {
                let extraActions = [];
                if (deleteOldDoc) {
                  extraActions.push({
                    action: "removeDoc",
                    params: {externalId: selectedDocument.externalId}
                  });
                  extraActions.push({
                    action: "setActiveDoc",
                    params: {externalId: newDocId.current}
                  });
                }
                if (refreshDocs) {
                  extraActions.push({action: "refreshDocs", params: {}});
                }

                newDocId.current = null;

                if (props.sendDocClear) {
                  props.sendDocClear();
                  //resetView();
                  setDirtyState((ds) => {
                    return {
                      ...ds,
                      docIsDirty: false,
                    }
                  });
                }
                dispatch(setGlobalVariable({
                  name: "savingDor",
                  value: false,
                }));
                //console.log("props.sendAdditionalActions ", props.sendAdditionalActions , "extraActions", extraActions);
                if (props.sendAdditionalActions && extraActions.length > 0) {
                  props.sendAdditionalActions(extraActions);
                }
              });
        });

        domElement.style.width = "inherit";
        domElement.style.height = "inherit";
        cornerstone.resize(domElement, false);
        context.filter = filterOriginal;
       // viewportClone.hideHanders = false;

        cornerstone.setViewport(
            domElement,
            viewportClone
        );

        const image = cornerstone.getImage(domElement);
        image._forceRender = false;
      }

      const onImageRendered = async () => {
        const imagePNG = enabledElement.canvas.toDataURL("image/png");

        function urltoFile(
            url,
            filename,
            mimeType
        ) {
          return fetch(url)
              .then(function (res) {
                return res.arrayBuffer();
              })
              .then(function (buf) {
                return new File(
                    [buf],
                    filename,
                    {type: mimeType}
                );
              });
        }

        urltoFile(
            imagePNG,
            "image.png",
            "image/png"
        ).then(function (file) {

          const documentUUID = uuidv4();
          const data = {
            path: `/${props.patientId}`,
            externalUniqueId: `${documentUUID}.internal`,
            date: selectedDocument.startDate,
            metadata: {
              docType: selectedDocument.docType?.__id,
              study: metadata.study,
              dicom: {},
              annotations: annotationsSerialized,
              saved: !deleteOldDoc,
              originalDoc: (selectedDocument.metadata.saved && selectedDocument.metadata.originalDoc) ?
                  selectedDocument.metadata.originalDoc :
                  {
                    externalId: selectedDocument.externalId,
                    page: currentPage
                  },
              parentData: {},
              settings: {},
            },
          };

          if (selectedDocument.metadata.operatorName) {
            data.metadata.operatorName =
                selectedDocument.metadata.operatorName;
          }
          if (selectedDocument.metadata.location) {
            data.metadata.location =
                selectedDocument.metadata.location;
          }
          if (selectedDocument.metadata.laterality) {
            data.metadata.laterality =
                selectedDocument.metadata.laterality;
          }
          if (selectedDocument.metadata.patientId) {
            data.metadata.patientId =
                selectedDocument.metadata.patientId;
          }
          if (selectedDocument.metadata.ey) {
            data.metadata.ey =
                selectedDocument.metadata.ey;
          }

          const meta = _.cloneDeep(metadata);
          // if we do have reference let them here - but just leave the one we are interested in ...
          if (
              meta &&
              meta.dicom &&
              meta.dicom["52009230"] &&
              meta.dicom["52009230"].Value
          ) {
            const PerFrameFunctionalGroupsSequence =
                meta.dicom["52009230"].Value;
            meta.dicom["52009230"].Value = [
              PerFrameFunctionalGroupsSequence[
              currentPage - 1
                  ],
            ];
          }

          if (
              meta &&
              meta.dicom &&
              meta.dicom["00280008"] &&
              meta.dicom["00280008"].Value
          ) {
            meta.dicom["00280008"].Value = 1;
          }

          if (
              meta &&
              meta.dicom &&
              meta.dicom["00080018"] &&
              meta.dicom["00080018"].Value
          ) {
            const genUUID =
                documentUUID +
                "." +
                currentPage;
            data.metadata.uid_parent =
                meta.dicom["00080018"].Value[0];
            meta.dicom["00080018"].Value[0] =
                genUUID;
            data.metadata.uid_gen =
                meta.dicom["00080018"].Value[0];
          }

          data.metadata.dicom = meta.dicom;

          if (deleteOldDoc && selectedDocument.metadata.emailMsgId) {
            data.metadata.emailMsgId = selectedDocument.metadata.emailMsgId;
          }

          const imageSaveFormData = new FormData();
          imageSaveFormData.append("metadata", JSON.stringify(data));
          imageSaveFormData.append("file", file);


          axios({
            method: "post",
            url: config.imageUploadURL,
            data: imageSaveFormData,
            headers: {
              Authorization: `Bearer ${window.keycloak ? window.keycloak.token : window.auth.token}`,
              "Content-Type": "multipart/form-data",
            },
          })
              .then(function (response) {

                newDocId.current = response.data.message;

                if (config.imageUploadAttachURL) {
                  domElement.addEventListener(
                      "cornerstoneimagerendered",
                      onImageRenderedPrev
                  );
                } else {
                  let extraActions = [];
                  if (deleteOldDoc) {
                    extraActions.push({
                      action: "removeDoc",
                      params: {externalId: selectedDocument.externalId}
                    });
                    extraActions.push({
                      action: "setActiveDoc",
                      params: {externalId: response.data.message}
                    });
                  }
                  if (refreshDocs) {
                    extraActions.push({action: "refreshDocs", params: {}});
                  }


                  dispatch(setGlobalVariable({
                    name: "savingDor",
                    value: false,
                  }));

                  const image = cornerstone.getImage(domElement);
                  image._forceRender = false;

                  if (props.sendDocClear) {
                    props.sendDocClear();
                    //resetView();
                    setDirtyState((ds) => {
                      return {
                        ...ds,
                        docIsDirty: false,
                      }
                    });
                  }
                  //console.log("props.sendAdditionalActions ", props.sendAdditionalActions , "extraActions", extraActions);
                  if (props.sendAdditionalActions && extraActions.length > 0) {
                    props.sendAdditionalActions(extraActions);
                  }
                }

                cornerstone.updateImage(domElement);

                setSavingBarVisible(false);

                setMessageTitle(t("Success !"));
                setMessage(t("Document uploaded. Thank you."));


              })
              .catch(function (response) {
                // handle error
                console.error(response);

                setSavingBarVisible(false);

                setMessageTitle(
                    t("Document upload error !")
                );
                setMessage(
                    t("Document not uploaded. Try again later.")
                );
              });
        });

        domElement.removeEventListener(
            "cornerstoneimagerendered",
            onImageRendered
        );

        _.forEach(tools, (tool) => {
          serializeTool(tool, true);
        });

        viewportClone.rotation = rot;
        //viewportClone.hideHanders = true;
        cornerstone.setViewport(domElement, viewportClone);

        if (!config.imageUploadAttachURL) {
          domElement.style.width = "inherit";
          domElement.style.height = "inherit";
          cornerstone.resize(domElement, false);
          context.filter = filterOriginal;
          //viewportClone.hideHanders = false;

          cornerstone.setViewport(
              domElement,
              viewportClone
          );
        }

        cornerstone.resize(domElement, true);
        context.filter = filterOriginal;
      }

      domElement.addEventListener(
          "cornerstoneimagerendered",
          onImageRendered
      );


      const context = enabledElement.canvas.getContext("2d");
      const filterOriginal = context.filter;

      let viewport = cornerstone.getViewport(domElement);
      let viewportClone = _.cloneDeep(viewport);

      domElement.style.width = `${enabledElement.image.width}px`;
      domElement.style.height = `${enabledElement.image.height}px`;

      // hide annotations ... and serialize them
      const serializeTool = (name, visible) => {
        let toolData =
            cornerstoneTools.getToolState(
                domElement,
                name
            );
        if (toolData && toolData.data) {
          const serialized =
              JSON.stringify(toolData);
          _.forEach(
              toolData.data,
              (singleState) => {
                if (visible !== undefined) {
                  singleState.visible =
                      visible;
                }
              }
          );
          return serialized;
        }

        return null;
      };

      const annotationsSerialized = {};
      annotationsSerialized['RotateViewPort'] = viewport.rotation;

      rot = viewport.rotation;
      viewportClone.rotation = 0.0;

      const image = cornerstone.getImage(domElement);
      image._forceRender = true;

      cornerstone.setViewport(
          domElement,
          viewportClone
      );

      _.forEach(tools, (tool) => {
        annotationsSerialized[tool] = serializeTool(
            tool,
            false
        );
      });

      cornerstone.resize(domElement, true);
      context.filter = filterOriginal;

    }
  }

  const saveDorDocumentOld = (enabledElement, domElement, refreshDocs=false, deleteOldDoc=false) => {
    if (enabledElement && enabledElement.image &&
        (!selectedDocument.metadata.finalPages || !selectedDocument.metadata.finalPages.finalPages.includes(currentPage))) {
      setSavingBarVisible(true);

      const context = enabledElement.canvas.getContext("2d");
      const filterOriginal = context.filter;

      let viewport = cornerstone.getViewport(domElement);
      let viewportClone = _.cloneDeep(viewport);

      domElement.style.width = `${enabledElement.image.width}px`;
      domElement.style.height = `${enabledElement.image.height}px`;

      // hide annotations ... and serialize them
      const serializeTool = (name, visible) => {
        let toolData =
            cornerstoneTools.getToolState(
                domElement,
                name
            );
        if (toolData && toolData.data) {
          const serialized =
              JSON.stringify(toolData);
          _.forEach(
              toolData.data,
              (singleState) => {
                if (visible !== undefined) {
                  singleState.visible =
                      visible;
                }
              }
          );
          return serialized;
        }

        return null;
      };

      const annotationsSerialized = {};
      _.forEach(tools, (tool) => {
        annotationsSerialized[tool] = serializeTool(
            tool,
            false
        );
      });

      const onImageRendered = () => {
        const imagePNG =
            enabledElement.canvas.toDataURL(
                "image/png"
            );
        function urltoFile(
            url,
            filename,
            mimeType
        ) {
          return fetch(url)
              .then(function (res) {
                return res.arrayBuffer();
              })
              .then(function (buf) {
                return new File(
                    [buf],
                    filename,
                    { type: mimeType }
                );
              });
        }

        urltoFile(
            imagePNG,
            "image.png",
            "image/png"
        ).then(function (file) {
          const documentUUID = uuidv4();
          const data = {
            path: `/${props.patientId}`,
            externalUniqueId: `${documentUUID}.internal`,
            date: selectedDocument.startDate,
            metadata: {
              docType: selectedDocument.docType?.__id,
              study: metadata.study,
              dicom: {},
              annotations: annotationsSerialized,
              saved: !deleteOldDoc,
              originalDoc: (selectedDocument.metadata.saved && selectedDocument.metadata.originalDoc) ?
                  selectedDocument.metadata.originalDoc :
                  {
                    externalId: selectedDocument.externalId,
                    page: currentPage
                  },
              parentData: {},
              settings: {},
            },
          };

          if (selectedDocument.metadata.operatorName) {
            data.metadata.operatorName =
                selectedDocument.metadata.operatorName;
          }
          if (selectedDocument.metadata.location) {
            data.metadata.location =
                selectedDocument.metadata.location;
          }
          if (selectedDocument.metadata.laterality) {
            data.metadata.laterality =
                selectedDocument.metadata.laterality;
          }
          if (selectedDocument.metadata.patientId) {
            data.metadata.patientId =
                selectedDocument.metadata.patientId;
          }

          const meta = _.cloneDeep(metadata);
          // if we do have reference let them here - but just leave the one we are interested in ...
          if (
              meta &&
              meta.dicom &&
              meta.dicom["52009230"] &&
              meta.dicom["52009230"].Value
          ) {
            const PerFrameFunctionalGroupsSequence =
                meta.dicom["52009230"].Value;
            meta.dicom["52009230"].Value = [
              PerFrameFunctionalGroupsSequence[
              currentPage - 1
                  ],
            ];
          }

          if (
              meta &&
              meta.dicom &&
              meta.dicom["00280008"] &&
              meta.dicom["00280008"].Value
          ) {
            meta.dicom["00280008"].Value = 1;
          }

          if (
              meta &&
              meta.dicom &&
              meta.dicom["00080018"] &&
              meta.dicom["00080018"].Value
          ) {
            const genUUID =
                documentUUID +
                "." +
                currentPage;
            data.metadata.uid_parent =
                meta.dicom["00080018"].Value[0];
            meta.dicom["00080018"].Value[0] =
                genUUID;
            data.metadata.uid_gen =
                meta.dicom["00080018"].Value[0];
          }

          data.metadata.dicom = meta.dicom;

          if(deleteOldDoc && selectedDocument.metadata.emailMsgId){
            data.metadata.emailMsgId = selectedDocument.metadata.emailMsgId;
          }

          const imageSaveFormData =
              new FormData();
          imageSaveFormData.append(
              "metadata",
              JSON.stringify(data)
          );
          imageSaveFormData.append("file", file);

          axios({
            method: "post",
            url: config.imageUploadURL,
            data: imageSaveFormData,
            headers: {
              Authorization: `Bearer ${window.keycloak ? window.keycloak.token : window.auth.token}`,
              "Content-Type":
                  "multipart/form-data",
            },
          })
              .then(function (response) {
                let extraActions = [];
                if(deleteOldDoc){
                  extraActions.push({action:"removeDoc",params:{externalId: selectedDocument.externalId}});
                  extraActions.push({action:"setActiveDoc",params:{externalId: response.data.message}});
                }
                if(refreshDocs){
                  extraActions.push({action:"refreshDocs",params:{}});
                }

                setSavingBarVisible(false);

                setMessageTitle(t("Success !"));
                setMessage(
                    t(
                        "Document uploaded. Thank you."
                    )
                );

                if (props.sendDocClear) {
                  props.sendDocClear();
                  //resetView();
                  setDirtyState((ds) => {
                    return {
                      ...ds,
                      docIsDirty: false,
                    }
                  });
                }
                //console.log("props.sendAdditionalActions ", props.sendAdditionalActions , "extraActions", extraActions);
                if(props.sendAdditionalActions && extraActions.length > 0){
                  props.sendAdditionalActions(extraActions);
                }

              })
              .catch(function (response) {
                // handle error
                console.error(response);

                setSavingBarVisible(false);

                setMessageTitle(
                    t("Document upload error !")
                );
                setMessage(
                    t(
                        "Document not uploaded. Try again later."
                    )
                );
              });
        });

        domElement.removeEventListener(
            "cornerstoneimagerendered",
            onImageRendered
        );

        _.forEach(tools, (tool) => {
          serializeTool(tool, true);
        });

        domElement.style.width = "inherit";
        domElement.style.height = "inherit";
        cornerstone.resize(domElement, false);
        context.filter = filterOriginal;

        cornerstone.setViewport(
            domElement,
            viewportClone
        );
      };
      domElement.addEventListener(
          "cornerstoneimagerendered",
          onImageRendered
      );

      cornerstone.resize(domElement, true);
      context.filter = filterOriginal;
    }
  }

  const handleOpenGrid = (type) => {
    let item = null;
    switch (type) {
      case "gridA":
        item = <EyonixGridA style={{ width: "100%", height: "100%" }} />;
        break;
      case "gridB":
        item = <EyonixGridB style={{ width: "100%", height: "100%" }} />;
        break;
      case "gridC":
        item = <EyonixGridC style={{ width: "100%", height: "100%" }} />
        break;
    }

    if(item) {
      setGridItem(item);
      setGridVisible(true);
    } else {
      setGridItem(null);
      setGridVisible(false);
    }


  }

  const rebuildViewportToImage = (viewport, image) => {
    if (viewport && image) {
      const scaleX = viewport.displayedArea.brhc.x / image.width;
      const scaleY = viewport.displayedArea.brhc.y / image.height;
      viewport.scale = viewport.scale * scaleX;
      viewport.displayedArea.brhc = {
        x: image.width,
        y: image.height,
      };
      viewport.translation = {
        x: viewport.translation.x / scaleX,
        y: viewport.translation.y / scaleY,
      };
    }
  };

  const loadImage = async (domElement, imageUrl, onLoaded, alternateCacheUrl) => {
    let cachedImage = undefined;
    for (let i = 0; i < 2; i++) {
      cachedImage = globalImageCache.get(alternateCacheUrl) || globalImageCache.get(imageUrl);
      if (cachedImage && Object.prototype.toString.call(cachedImage) === "[object Promise]") {
        try {
          // it is a Promise - wait for results and re-fetch image from cache
          await cachedImage;
        } catch (error) {
          console.error("loadImage error", error);
          if (cachedImage == globalImageCache.get(alternateCacheUrl)) {
            globalImageCache.remove(alternateCacheUrl);
          }
          if (cachedImage == globalImageCache.get(imageUrl)) {
            globalImageCache.remove(imageUrl);
          }
          cachedImage = null;
        }
      } else {
        break;
      }
    }

    if (cachedImage && Object.prototype.toString.call(cachedImage) !== "[object Promise]") {
      onLoaded(cachedImage);
    } else {
      const loadPromise = cornerstone.loadImage(imageUrl);
      globalImageCache.set(imageUrl, loadPromise);
      loadPromise.then(function (image) {
        globalImageCache.set(imageUrl, image);
        onLoaded(image);
      }).catch(error => {
        dispatch(setSnackbar({type: "error", message: t("Error while loading image.")}));
        if (cachedImage == globalImageCache.get(alternateCacheUrl)) {
          globalImageCache.remove(alternateCacheUrl);
        }
        if (cachedImage == globalImageCache.get(imageUrl)) {
          globalImageCache.remove(imageUrl);
        }
      });
    }
  };

  const loadImageEx = async (imageUrl, alternateCacheUrl, abortController) => {
    let cachedImage = undefined;
    for (let i = 0; i < 2; i++) {
      if (abortController.signal.aborted) return;
      cachedImage = globalImageCache.get(alternateCacheUrl) || globalImageCache.get(imageUrl);
      if (cachedImage && Object.prototype.toString.call(cachedImage) === "[object Promise]") {
        // it is a Promise - wait for results and re-fetch image from cache
        await cachedImage;
      } else {
        break;
      }
    }

    if (cachedImage && Object.prototype.toString.call(cachedImage) !== "[object Promise]") {
      return cachedImage;
    } else if (!abortController.signal.aborted) {
      const loadPromise = cornerstone.loadImage(imageUrl);
      globalImageCache.set(imageUrl, loadPromise);
      const image = await loadPromise;
      globalImageCache.set(imageUrl, image);
      return image;
    }
  };

  const reloadImages = async () => {
    const domElement = rootElement.current;
    let enabled = false;
    const elements = cornerstone.getEnabledElements();
    for (const element of elements) {
      enabled = element.element === domElement;
      if (enabled) break;
    }

    if (!enabled) {
      cornerstone.enable(domElement);

      // const eventData = cornerstone.getEnabledElement(domElement);
      // console.log("eventData", eventData);

      // domElement.addEventListener('cornerstoneimagerendered', onImageRendered);
      // setInitialized(true);
    }

    setLoading(true);
    setLoadingBarVisible(true);
    setLoadingBuffering(true);

    let taskExecutor = new TaskExecutor(config.modules.viewer.image.concurrencyLoad || 5);
    for (let cp = 1; cp <= document.pageCount; cp++) {
      const imageUrlPageFull = getImageUrlFull(cp);

      // if ($(".buffer-btn").length === 0) {
      //   return;
      // }

      $(".progress-label").html(`Loading ${cp} \\ ${document.pageCount}`);
      if (controller.signal.aborted) break;
      await taskExecutor.addTask("HI"+ cp, loadImageEx(imageUrlPageFull, null, controller));
      if (config.modules.viewer.image.concurrencyLoadLoRes) {
        if (controller.signal.aborted) break;
        const imageUrlPage = getImageUrl(cp);
        await taskExecutor.addTask('LO' + cp, loadImageEx(imageUrlPage, null, controller));
      }
    }
    if (!controller.signal.aborted) {
      await taskExecutor.awaitAll();

      setLoadingBuffering(false);

      // console.log("loaded ...", localCache);
      reloadImage();
    } else {
      setLoadingBuffering(false);
      reloadImage();
    }
  };

  const reloadImage = () => {
    const domElement = rootElement.current;
    let enabled = false;
    const elements = cornerstone.getEnabledElements();
    for (const element of elements) {
      enabled = element.element === domElement;
      if (enabled) break;
    }

    if (!enabled) {
      cornerstone.enable(domElement);

      // const eventData = cornerstone.getEnabledElement(domElement);
      // console.log("eventData", eventData);

      // domElement.addEventListener('cornerstoneimagerendered', onImageRendered);
      // setInitialized(true);
    }

    setLoading(true);
    setLoadingBarVisible(true);

    const imageUrlPage = getImageUrl(currentPage);
    const imageUrlPageFull = getImageUrlFull(currentPage);

    loadImage(
        domElement,
        imageUrlPage,
        (image) => {
          rebuildViewportToImage(
              cornerstone.getEnabledElement(domElement).viewport,
              image,
              imageDicomCornerstone
          );

          setImageDicomCornerstone(image);
          setImageDicomCornerstoneBase(image);
          // rebuildViewportToImage(
          //     cornerstone.getEnabledElement(domElement).viewport,
          //     image,
          //     cornerstone.getEnabledElement(domElement)
          // );

          setVisiblePage(currentPage);

          // FIXME: We do need to discuss this please
          // if(!props.historyMode)
          //     cornerstone.fitToWindow(domElement);

          // order is important ! and that needs ti be last
          setLoading(false);

          imageLoadDebounce(() => {
            loadImage(domElement, imageUrlPageFull, (image) => {
              setLoadingBarVisible(false);
            });
          });
        },
        imageUrlPageFull
    );
  };

  const [wheelPosition, setWheelPosition] = useState(0);

  const onWheeEvent = (wp) => (e) => {
    if (document.pageCount === 1 && props.openNextDocumentInActive) {
      props.openNextDocumentInActive(e.nativeEvent.wheelDeltaY < 0 ? 1 : -1)
    } else {
      const currentWheelPosition = wp + e.nativeEvent.wheelDeltaY;
      setWheelPosition(currentWheelPosition);
    }

  };

  const [newPageCache, setNewPageCache] = useState(null);

  useEffect(() => {
    // FIXME: 100 - go into config??? for wheel sensitivity?
    //  100 looks like aritray value - may be wrong
    const moveValue =
        Math.sign(wheelPosition) *
        Math.floor(Math.abs(wheelPosition / 100));
    if (Math.abs(moveValue) > 0) {
      let newPage = currentPage - moveValue;
      if (newPage > document.pageCount) {
        newPage = document.pageCount;
      }
      if (newPage < 1) {
        newPage = 1;
      }
      if (!dirtyState.docIsDirty) {
        setCurrentPage(newPage);
        setWheelPosition(0);
      } else {
        setMessageTitleAnnotation(t("You haven't saved the tools."));
        setMessageAnnotation(t("Do you want to leave?"));
        setNewPageCache(newPage);
      }
    }
    return () => { };
  }, [wheelPosition, currentPage, document]);

  const currentPageController = new AbortController();

  useEffect(() => {
    if (document && document.pageCount > 1 && patientPreferencesObject.framePreloadMode &&
        (patientPreferencesObject.framePreloadMode === 'smart' || patientPreferencesObject.framePreloadMode === 'background')) {
      const abortController = currentPageController;
      const preload = async () => {
        let taskExecutor = new TaskExecutor(config.modules.viewer.image.concurrencyLoad || 5);
        const preloadCount = config.modules.viewer.framePreload?.smart || 5;
        for (let i = preloadCount; i >= -1 * preloadCount; i--) {
          const cp = currentPage + i;
          if (cp > document.pageCount || cp <= 0) {
            continue;
          }
          const imageUrlPageFull = getImageUrlFull(cp);

          if (abortController.signal.aborted) break;
          await taskExecutor.addTask('HI' + cp, loadImageEx(imageUrlPageFull, null, abortController));
          if (config.modules.viewer.image.concurrencyLoadLoRes) {
            if (abortController.signal.aborted) break;
            const imageUrlPage = getImageUrl(cp);
            await taskExecutor.addTask('LO' + cp, loadImageEx(imageUrlPage, null, abortController));
          }
        }
      };
      preload();
    }

    return () => {
      currentPageController.abort();
    };
  }, [currentPage]);

  const resetView = () => {
    setDirtyState({
      id: null,
      annotationsRendered: false,
      docIsDirty: false,
    });

    dispatch(
        setGlobalVariable({
          name: variableName,
          value: null,
        })
    );
    return () => { };
  };

  useEffect(
      () => {
        const domElement = rootElement.current;
        let enabledElement;
        const elements = cornerstone.getEnabledElements();
        for (const element of elements) {
          const enabled = element.element === domElement;
          if (enabled) {
            enabledElement = element;
            break;
          }
        }

        if (enabledElement && enabledElement.image) {
          if (metadata) {

            let viewport = cornerstone.getViewport(domElement);
            viewport.rotation = 0.0;

            if(metadata.annotations && metadata.annotations['RotateViewPort']) {
              const rotateViewPortData = JSON.parse(
                  metadata.annotations['RotateViewPort']
              );

              viewport.rotation = rotateViewPortData;
            }

            cornerstone.setViewport(domElement, viewport);

            //  if (metadata.annotations) {
            _.forEach(tools, (tool) => {
              cornerstoneTools.setToolActiveForElement(
                  domElement,
                  tool,
                  {
                    mouseButtonMask: 1,
                    deleteIfHandleOutsideImage: false,
                    preventHandleOutsideImage: false,
                  }
              );
              cornerstoneTools.clearToolState(domElement, tool);
              if (
                  metadata.annotations &&
                  metadata.annotations[tool]
              ) {

                const toolData = JSON.parse(
                    metadata.annotations[tool]
                );
                // const domElement = rootElement.current;

                _.forEach(toolData.data, (d) => {
                  const toolDataSingle = _.cloneDeep(d);
                  toolDataSingle.visible = true;
                  delete toolDataSingle.uuid;
                  cornerstoneTools.addToolState(
                      domElement,
                      tool,
                      toolDataSingle
                  );
                });

                cornerstone.setViewport(domElement, viewport);
              }
            });


            setTimeout(() => {
              if (!loadingBarVisible && selectedDocument)
                setDirtyState({
                  id: selectedDocument.externalId,
                  annotationsRendered: true,
                  docIsDirty: false,
                });
            }, 1000);

            setActiveTool(domElement);
            cornerstone.updateImage(domElement);
            //ESD-18 Image display
            if (document.pageCount === 1 || currentPage === 1)
              cornerstone.fitToWindow(domElement);
            //    }
          }
        }
        return () => { };
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [metadata, loadingBarVisible, lastDisplayedImageId]
  );

  useEffect(() => {
    if (!referencesSOP && imageDicomCornerstone) {
      const onImageRendered = (e) => {
        let viewport = cornerstone.getViewport(domElement);
        setViewportData(viewport);
      };

      const domElement = rootElement.current;
      let enabled = false;
      const elements = cornerstone.getEnabledElements();
      for (const element of elements) {
        enabled = element.element === domElement;
        if (enabled) break;
      }

      if (enabled) {
        let canvasDOM = domElement.getElementsByTagName("canvas");
        canvasDOM[0].setAttribute('id', document.externalId +"_"+ props.xupId);

        domElement.addEventListener(
            "cornerstoneimagerendered",
            onImageRendered
        );

        const timeoutId = setTimeout(() => {
          cornerstone.updateImage(domElement);
        }, 1);

        return () => {
          clearTimeout(timeoutId);
          domElement.removeEventListener(
              "cornerstoneimagerendered",
              onImageRendered
          );
        };
      }
    }
    return () => { };
  }, [
    imageDicomCornerstone,
    toolbarViewer,
    metadata,
    referencesSOP,
    props,
    loadingBarVisible,
  ]);

  const [dirtyState, setDirtyState] = useState({
    id: null,
    annotationsRendered: false,
    docIsDirty: false,
  });

  useEffect(() => {
    if (toolbarViewer) {
      let p = toolbarViewer.enhanceModeParameters;
      //let isNegative = toolbarViewer.enhanceMode?.length > 0 && toolbarViewer.enhanceMode?.findIndex((el) => el === "negative") > -1;
     // let haveChanel = toolbarViewer.channelsMode != null;

      if (
          !dirtyState.docIsDirty &&
          (p.blur !== 0 ||
              p.brightness !== 0 ||
              p.contrast !== 0 ||
              p.gamma !== 0 ||
              p.sharpen !== 0)
      ) {
        if (props.sendDocDirty) {
          props.sendDocDirty(selectedDocument.externalId);
          setDirtyState({
            id: selectedDocument.externalId,
            annotationsRendered: true,
            docIsDirty: true,
          });
        }
      }

      if(toolbarViewer.hasOwnProperty("grid")) {
        handleOpenGrid(toolbarViewer.grid)
      }
    }
    return () => { };
  }, [toolbarViewer]);

  useEffect(() => {
    if (
        !referencesSOP &&
        imageDicomCornerstone &&
        dirtyState.annotationsRendered
    ) {
      const onDirty = (e) => {
        if (
            !dirtyState.docIsDirty &&
            selectedDocument &&
            dirtyState.id === selectedDocument.externalId
        ) {
          if (props.sendDocDirty) {
            props.sendDocDirty(selectedDocument.externalId);
            setDirtyState({
              id: selectedDocument.externalId,
              annotationsRendered: true,
              docIsDirty: true,
            });
          }
        }
      };

      const domElement = rootElement.current;
      let enabled = false;
      const elements = cornerstone.getEnabledElements();
      for (const element of elements) {
        enabled = element.element === domElement;
        if (enabled) break;
      }

      if (enabled) {
        domElement.addEventListener(
            "cornerstonetoolsmeasurementadded",
            onDirty
        );
        domElement.addEventListener(
            "cornerstonetoolsmeasurementmodified",
            onDirty
        );
        domElement.addEventListener(
            "cornerstonetoolsmeasurementremoved",
            onDirty
        );

        return () => {
          domElement.removeEventListener(
              "cornerstonetoolsmeasurementadded",
              onDirty
          );
          domElement.removeEventListener(
              "cornerstonetoolsmeasurementmodified",
              onDirty
          );
          domElement.removeEventListener(
              "cornerstonetoolsmeasurementremoved",
              onDirty
          );
        };
      }
    }
    return () => { };
  }, [dirtyState]);

  const controller = new AbortController();

  useEffect(
      () => {

        API.getMetadataForDocuments(props.patientId, [
            selectedDocument.__id,
          ], controller.signal).then((metadata) => {
            // console.warn("metadata", metadata, selectedDocument);

            const meta = metadata[selectedDocument.__id];
            setMetadata(meta);

            let viewData = undefined;
            if (
                meta &&
                meta.dicom &&
                meta.dicom["52009230"] &&
                meta.dicom["52009230"].Value
            ) {
              // ...
              viewData = {
                references: {},
              };

              const PerFrameFunctionalGroupsSequence =
                  meta.dicom["52009230"].Value;

              let sequenceNumber = 1;

              for (let frame of PerFrameFunctionalGroupsSequence) {
                const OphthalmicFrameLocationSequence =
                    frame["00220031"].Value["0"];
                const ReferencedSOPInstanceUID =
                    OphthalmicFrameLocationSequence["00081155"]
                        .Value[0];

                if (!viewData.references[ReferencedSOPInstanceUID]) {
                  viewData.references[ReferencedSOPInstanceUID] = {
                    frames: [],
                  };
                }

                const FrameContentSequence =
                    frame["00209111"].Value["0"];
                const ReferenceCoordinates =
                    OphthalmicFrameLocationSequence["00220032"].Value;
                const OphthalmicImageOrientation =
                    OphthalmicFrameLocationSequence["00220039"].Value[0];
                const StackID =
                    FrameContentSequence["00209056"].Value[0];
                const InStackPositionNumber =
                    FrameContentSequence["00209057"].Value[0];

                const points = [];
                for (let i = 0; i < ReferenceCoordinates.length; i += 2) {
                  points.push({
                    x: ReferenceCoordinates[i + 1],
                    y: ReferenceCoordinates[i],
                  });
                }

                const r = {
                  sequenceNumber: sequenceNumber,
                  stack: StackID,
                  stackPosition: InStackPositionNumber,
                  coordinates: points,
                  orientation: OphthalmicImageOrientation,
                };

                viewData.references[
                    ReferencedSOPInstanceUID
                    ].frames.push(r);
                sequenceNumber++;
              }
            }

            dispatch(
                setViewData({
                  index: props.viewerId,
                  data: viewData,
                })
            );

            // I have setting per frame they may be used by original image ...
            // console.error("dicom", PerFrameFunctionalGroupsSequence);
          });

        if (document.pageCount > 1 && patientPreferencesObject.framePreloadMode &&
            (patientPreferencesObject.framePreloadMode === 'background' ||
                patientPreferencesObject.framePreloadMode === 'block' ||
                patientPreferencesObject.framePreloadMode === 'smart')) {

          const pageCount = patientPreferencesObject.framePreloadMode === 'smart' ?
              (config.modules.viewer.framePreload?.smart || 5) :
              document.pageCount;

          const preload = async () => {
            let taskExecutor = new TaskExecutor(config.modules.viewer.image.concurrencyLoad || 5);
            for (let cp = 1; cp <= pageCount && cp <= document.pageCount; cp++) {
              const imageUrlPageFull = getImageUrlFull(cp);

              if (controller.signal.aborted) break;
              await taskExecutor.addTask('HI' + cp, loadImageEx(imageUrlPageFull, null, controller));
              if (config.modules.viewer.image.concurrencyLoadLoRes) {
                if (controller.signal.aborted) break;
                const imageUrlPage = getImageUrl(cp);
                await taskExecutor.addTask('LO' + cp, loadImageEx(imageUrlPage, null, controller));
              }
            }
          };
          preload();

          reloadImage();
        // } else if (document.pageCount > 1 && patientPreferencesObject.framePreloadMode && patientPreferencesObject.framePreloadMode === "block") {
        //   reloadImages();
        } else {
          reloadImage();
        }


        return () => {
          controller.abort();
          dispatch(
              setViewData({
                index: props.viewerId,
                data: undefined,
              })
          );
        };
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [selectedDocument, props.patientId]
  );

  const bufferImages = () => {
    reloadImages();
  };

  useEffect(
      () => {
        // this is in fact connected as a number to sequenceNumber above
        // we may need to precisly do the same method in rended but that should be stack related
        dispatch(
            setViewCurrentPage({
              index: props.viewerId,
              page: currentPage,
            })
        );
        return () => { };
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [currentPage, props]
  );

  useEffect(
      () => {
        if (toolbarViewer) {
          const newToolBarDef = _.cloneDeep(toolbarViewer);
          newToolBarDef.haveSquareMeasurements = pixelSpacing && pixelSpacing.rowPixelSpacing === pixelSpacing.columnPixelSpacing;
          if (toolbarViewer.haveSquareMeasurements !== newToolBarDef.haveSquareMeasurements) {
            dispatch(
                setGlobalVariable({
                  name: variableName,
                  value: newToolBarDef,
                })
            );
          }
        }
      },
      [pixelSpacing, toolbarViewer]
  );

  useEffect(
      () => {
        setPixelSpacing(null);
        if (!loading) {
          const imageUrlPage = getImageUrl(currentPage);
          const imageUrlPageFull = getImageUrlFull(currentPage);
          const cachedImage =
              globalImageCache.get(imageUrlPageFull) || globalImageCache.get(imageUrlPage);
          if (cachedImage && Object.prototype.toString.call(cachedImage) !== "[object Promise]") {
            const domElement = rootElement.current;
            rebuildViewportToImage(
                cornerstone.getEnabledElement(domElement).viewport,
                cachedImage,
                imageDicomCornerstone
            );

            // dicom should exist, we need to be sure it is !
            const getPixelSpacingLocal = () => {
              let spacing = null;
              if (metadata && metadata.dicom) {
                // console.log("imageDicomCornerstone", imageDicomCornerstone);
                // console.log("imageDicomCornerstoneBase", imageDicomCornerstoneBase);

                let pixelSpacingTable = [0, 0];
                if (metadata.dicom["00280030"]) {
                  pixelSpacingTable = metadata.dicom["00280030"].Value;
                } else if (metadata.dicom["00181164"]) {
                  pixelSpacingTable = metadata.dicom["00181164"].Value;
                } else if (metadata.dicom["52009229"]) {
                  const SharedFunctionalGroupsSequence = metadata.dicom["52009229"].Value[0];
                  if (SharedFunctionalGroupsSequence["00289110"]) {
                    const PixelMeasuresSequence = SharedFunctionalGroupsSequence["00289110"].Value[0];
                    if (PixelMeasuresSequence["00280030"]) {
                      pixelSpacingTable = PixelMeasuresSequence["00280030"].Value;
                    }
                  }
                }

                if (pixelSpacingTable[0] > 0 && pixelSpacingTable[1] > 0) {
                  spacing = {
                    rowPixelSpacing: pixelSpacingTable[0],
                    columnPixelSpacing: pixelSpacingTable[1],
                  }
                }
              }

              return spacing;
            }

            const ps = getPixelSpacingLocal();
            if (ps) {
              cachedImage.rowPixelSpacingEx = ps.rowPixelSpacing;
              cachedImage.columnPixelSpacingEx = ps.columnPixelSpacing;
              // FIXME: we need to explore options here ...
              // cachedImage.rowPixelSpacing = ps.rowPixelSpacing;
              // cachedImage.columnPixelSpacing = ps.columnPixelSpacing;
            }
            setPixelSpacing(ps);

            setImageDicomCornerstone(cachedImage);
            setImageDicomCornerstoneBase(cachedImage);

            setVisiblePage(currentPage);

            const cachedImageFull = globalImageCache.get(imageUrlPageFull);
            if (!cachedImageFull || Object.prototype.toString.call(cachedImageFull) === "[object Promise]" ) {
              reloadImage();
            }
          } else {
            if (!loading) {
              reloadImage();
            }
          }
          return () => { };
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [currentPage, loading, loadingBarVisible, metadata]
  );

  useEffect(() => {
    if (imageDicomCornerstone) {
      const domElement = rootElement.current;

      cornerstone.displayImage(domElement, imageDicomCornerstone);
      // reloadAnnotations(domElement);
      // console.log("imageDicomCornerstone", imageDicomCornerstone.imageId);
      setLastDisplayedImageId(imageDicomCornerstone.imageId);
      cornerstone.updateImage(domElement);
    }
    return () => { };
  }, [imageDicomCornerstone]);

  useEffect(() => {
    let filter = "";
    let sharpenValue = 0;
    let blurValue = 0;
    _.forEach(enhanceSelected, (enhanceMethod) => {
      if (filter.length > 0) {
        filter += " ";
      }
      switch (enhanceMethod) {
        case "sharpen":
          sharpenValue =
              enhanceProperties && enhanceProperties.sharpen
                  ? enhanceProperties.sharpen
                  : 0;
          break;
        case "blur":
          blurValue =
              enhanceProperties && enhanceProperties.blur
                  ? enhanceProperties.blur
                  : 0;
          // blurValue = blurValue / 20.0;
          // filter += `blur(${blurValue}px)`;
          break;
        case "negative":
          filter += "invert(1)";
          break;
        case "brightness":
          let brightValue =
              enhanceProperties && enhanceProperties.brightness
                  ? enhanceProperties.brightness
                  : 0;
          brightValue = brightValue / 100.0 + 1;
          filter += `brightness(${brightValue})`;
          break;
        case "contrast":
          let contrastValue =
              enhanceProperties && enhanceProperties.contrast
                  ? enhanceProperties.contrast
                  : 0;
          contrastValue = contrastValue / 100.0 + 1;
          filter += `contrast(${contrastValue})`;
          break;
        case "gamma":
          let gammaValue =
              enhanceProperties && enhanceProperties.gamma
                  ? enhanceProperties.gamma
                  : 0;
          gammaValue = gammaValue / 100.0 + 1;
          filter += `saturate(${gammaValue})`;
          break;
        default:
          break;
      }
    });

    setGlobalSharpenValue(sharpenValue);
    setGlobalBlurValue(blurValue);

    const domElement = rootElement.current;

    let enabledElement;
    const elements = cornerstone.getEnabledElements();
    for (const element of elements) {
      const enabled = element.element === domElement;
      if (enabled) {
        enabledElement = element;
        break;
      }
    }

    if (enabledElement && enabledElement.image) {
      const context = enabledElement.canvas.getContext("2d");
      context.filter = filter.length === 0 ? "none" : filter;
      cornerstone.updateImage(domElement);
    }

    return () => { };
  }, [enhanceSelected, enhanceProperties, imageDicomCornerstoneBase]);

  useEffect(() => {
    if (channelsSelected || globalSharpenValue || globalBlurValue) {
      if (imageDicomCornerstoneBase) {
        getImageChannel(
            imageDicomCornerstoneBase,
            channelsSelected,
            {
              sharpen: globalSharpenValue,
              blur: globalBlurValue,
            },
            (newImage) => {
              setImageDicomCornerstone(newImage);
            }
        );
      }
    } else {
      setImageDicomCornerstone(imageDicomCornerstoneBase);
    }
    return () => { };
  }, [
    channelsSelected,
    globalBlurValue,
    globalSharpenValue,
    imageDicomCornerstoneBase,
  ]);

  const getOverlayStyle = () => {
    let styleClass = "overlay";
    if (document && document.pageCount && document.pageCount > 1) {
      styleClass += " with-scroll";
    }
    return styleClass;
  };

  const frameNumberFormat = (value) => {
    // return `${value}/${document.pageCount}`;
    return `${document.pageCount - value + 1}`;
  };

  const [message, setMessage] = React.useState(null);
  const [messageTitle, setMessageTitle] = React.useState(t("Information"));

  const [messageAnnotation, setMessageAnnotation] = React.useState(null);
  const [messageTitleAnnotation, setMessageTitleAnnotation] = React.useState(
      t("Information")
  );

  const dropAnnotation = () => {
    if (props.sendDocClear) {
      props.sendDocClear();
      setDirtyState({
        id: null,
        annotationsRendered: false,
        docIsDirty: false,
      });
    }

    setMessageAnnotation(null);
    setMessageTitleAnnotation(t("Information"));
    setCurrentPage(newPageCache);
    setWheelPosition(0);
  };

  return (
      <div
          ref={parentElement}
          onWheel={onWheeEvent(wheelPosition)}
          className={classes.base}
          style={{ position: "relative" }}
      >
        <MessageBox
            onClose={() => {
              setMessage(null);
              setMessageTitle(t("Information"));
            }}
            title={messageTitle}
            message={message}
            open={!!message}
        />

        <MessageBox
            onClose={() => {
              setMessageAnnotation(null);
              setMessageTitleAnnotation(t("Information"));
            }}
            onAccept={() => {
              dropAnnotation();
            }}
            title={messageTitleAnnotation}
            haveAccept={{ yes: "leave", no: "cancel" }}
            message={messageAnnotation}
            open={!!messageAnnotation}
            disableOnAccept
        />

        {gridVisible && <div style={{ opacity: 0.5, pointerEvents: "none", position: "absolute", height: "100%", width: "inherit" }}>
          {gridItem}
        </div>
        }

        <div className={classes.base} ref={rootElement} id={`${config.imageDownloadURL}/${document.externalId}/attachment/`}/>

        {loadingBarVisible && (
            <div className="image-progress">
              <BoldLinearProgress color={"secondary"} />
            </div>
        )}
        {savingBarVisible && (
            <div className="image-progress">
              <BoldLinearProgress color={"primary"} />
            </div>
        )}

        {document && document.pageCount > 1 && (
            <div className="image-scroll">
              <Slider
                  orientation="vertical"
                  min={1}
                  max={document.pageCount}
                  value={document.pageCount - currentPage + 1}
                  onChange={(event, newValue) =>
                      setCurrentPage(document.pageCount - newValue + 1)
                  }
                  track="inverted"
                  valueLabelFormat={frameNumberFormat}
              />
            </div>
        )}
        {loadingBuffering && (
            <div>
              <div className={getOverlayStyle() + " full-screen-loading"}>
                <div className="progress-label">
                  Loading ...
                </div>
              </div>
            </div>
        )}
        {toolbarViewer && toolbarViewer.imageInformation === "info" && !props.hideInformation && (
            <div>
              <div className={getOverlayStyle() + " top-left"}>
                {patientObject && (
                    <div>
                                <span style={{ textTransform: "uppercase" }}>
                                    {patientObject.familyName}
                                </span>{" "}
                      {patientObject.firstName}
                    </div>
                )}
                {patientObject && (
                    <div>
                      <strong>
                        {patientObject
                            ? patientObject.hospitalNumber
                            : ""}
                      </strong>
                    </div>
                )}
                {document && document.pageCount > 1 && (
                    <div className="buffer-btn" onClick={bufferImages}>
                      Buffer pages
                    </div>
                )}
              </div>
              <div className={getOverlayStyle() + " top-right"}>
                <div>
                  {t("Location")}{" "}
                  <strong>
                    {document
                        ? document.metadata.location
                            ? document.metadata.location
                            : t("[UNSET]")
                        : t("[UNSET]")}
                  </strong>
                </div>
                <div>
                  {t("Operator")}{" "}
                  <strong>
                    {document
                        ? document.metadata.operatorName
                            ? document.metadata.operatorName
                            : t("[UNSET]")
                        : t("[UNSET]")}
                  </strong>
                </div>
              </div>
              {!loadingBarVisible && (
                  <div className={getOverlayStyle() + " bottom-left"}>
                    <div style={{ fontSize: "80%" }}>{t("Tools")}</div>
                    <div>
                      {t("Zoom")}{" "}
                      {viewportData
                          ? `${Math.round(viewportData.scale * 100)}%`
                          : 0}
                    </div>
                    {/* <div>WW/WC</div> */}
                  </div>
              )}
              {/*{props.currentPage && <div onClick={()=>{*/}
              {/*    if(props.backToFrames) {*/}
              {/*        props.backToFrames()*/}
              {/*    }*/}
              {/*}}>*/}
              {/*    <ArrowBackIcon/>*/}
              {/*</div>*/}
              {/*}*/}
              <div className={getOverlayStyle() + " bottom-right"}>
                <div>
                  <strong>
                    {Formatter.formatProcedureNameSimple(
                        t,
                        document
                            ? document.metadata.procedureName
                            : undefined
                    )}
                  </strong>
                </div>
                <div className={classes.laterality}>
                  {Formatter.formatLaterality(
                      document
                          ? document.metadata.laterality
                          : undefined
                  )}
                </div>
                {document.pageCount > 1 && (
                    <div style={{textAlign: 'right'}}>
                      {t('Frame')}:{' '}
                      <b>
                        {visiblePage} / {document.pageCount}
                      </b>
                    </div>
                )}
              </div>
            </div>
        )}
      </div>
  );
}

export default ViewDocumentDicom;

